import { render } from "./DesktopLicenseManagement.vue?vue&type=template&id=44aee8fc&scoped=true"
import script from "./DesktopLicenseManagement.vue?vue&type=script&lang=js"
export * from "./DesktopLicenseManagement.vue?vue&type=script&lang=js"

import "./DesktopLicenseManagement.vue?vue&type=style&index=0&id=44aee8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44aee8fc"]])

export default __exports__